import React from 'react';
import './Contact.css';
import { FaPhoneAlt, FaWhatsapp } from 'react-icons/fa';

const ContactPage = () => {
  return (
    <div className="merged-contact-section">
      {/* Unified Title */}
      <h2 className="contact-heading">Contact Us</h2>

      {/* Content Container */}
      <div className="contact-content">
        {/* Left Info Section */}
        <div className="contact-info">

          <h3>Trust Head's</h3>
          <div className="trustee-members">
            {/* Trustee 1 */}
            <div className="member-card">
              <div className="member-content">
                <img src="/new_prof.jpeg" alt="Trustee 1" />
                <div className="member-text">
                  <p><strong>Mr.T.Nanthakumar,BE.,</strong></p>
                  <p>Founder & President</p>
                  <p><FaWhatsapp color="green" /> <a href="https://wa.me/919976992375" target="_blank" rel="noreferrer">9976992375</a></p>
                  <p><FaPhoneAlt color="#000" /> <a href="tel:+919976992375">99769 92375</a></p>
                </div>
              </div>
              
            </div>
         
            {/* Trustee 2 */}
            <div className="member-card">
              <div className="member-content">
                <img src="new.jpg" alt="Trustee 2" />
                <div className="member-text">
                  <p><strong>Mr.P.Arumugam, BBA.,</strong></p>
                  <p>Secretary</p>
                  <p><FaWhatsapp color="green" /> <a href="https://wa.me/919840716807" target="_blank" rel="noreferrer">9840716807</a></p>
                                      <p><FaPhoneAlt color="#000" /> <a href="tel:+919840716807">98407 16807</a></p>

                </div>
              </div>
            </div>
          </div>
                    <p style={{marginTop:"50px"}}><strong>Address:</strong> 68, ROJA COMPLEX, SANNATHI STREET,JAYANKONDAM, ARIYALUR (DT), PINCODE - 621802. TAMILNADU, INDIA</p>

        </div>

        {/* Right Contact Form */}
        <div className="contact-form">
          <form>
            <input type="text" placeholder="Your Name" required />
            <input type="email" placeholder="Your Email" required />
            <textarea placeholder="Your Message" rows="5" required></textarea>
            <button type="submit">Submit</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
